/* eslint-disable */
import React, { useEffect, useState } from "react";
import {
  Loading3QuartersOutlined,
  CloseCircleOutlined,
  FrownOutlined
} from "@ant-design/icons";
import { Spin } from "antd";
import "antd/lib/modal/style/index.css";
import "./index.css";

export default function ScreenQr(props) {
  const [position, setPosition] = useState(null);
  const [action, setAction] = useState(false);
  const [isShow, setShow] = useState(true);
  const [error, setError] = useState(false);

  function showError() {
    setPosition({
      width: "200px",
      top: `calc(50% - 200px)`
    });
    setError(true);
  }
  useEffect(() => {
    if (props.imgUrl) {
      const img = new Image();
      img.onload = () => {
        setPosition({
          width: (img.naturalWidth || img.width) + "px",
          top: `calc(50% - ${(img.naturalHeight || img.height) / 2}px)`
        });
      };
      img.onerror = () => {
        setPosition({
          width: "200px",
          top: `calc(50% - 200px)`
        });
        setError(true);
      };
      img.src = props.imgUrl;
    }
  }, [props.imgUrl]);
  useEffect(() => {
    props.error && showError();
  }, [props.error]);
  // console.log('ScreenImg', position)

  function close() {
    setAction(true);
    setTimeout(() => {
      setShow(false);
      props.onClose && props.onClose();
    }, 1000);
  }

  return (
    isShow && (
      <div className="screen-img">
        <div className="ant-modal-mask spin">
          <Spin
            spinning={!position}
            style={{
              marginTop: "calc(50% - 60px)"
            }}
            indicator={
              <Loading3QuartersOutlined
                spin
                style={{
                  fontSize: "60px"
                }}
              />
            }
          />
        </div>
        {position && (
          <div className={`ant-modal-wrap ${action ? "bounceOut" : ""}`}>
            <div className="ant-modal" style={position}>
              <CloseCircleOutlined className="close-btn" onClick={close} />
              {error ? (
                <div
                  style={{
                    color: "white",
                    textAlign: "center"
                  }}
                >
                  <FrownOutlined
                    style={{
                      fontSize: "100px",
                      marginBottom: "10px"
                    }}
                  />
                  <div>内容没有加载完成，请重试</div>
                </div>
              ) : (
                  <img alt="qrcode" src={props.imgUrl} />
                )}
              <div className="extra">{props.extra}</div>
            </div>
          </div>
        )}
      </div>
    )
  );
}
/* eslint-disable */
